
type HeaderColumn = {
  label: string;
  key: string;
  style?: React.CSSProperties;
  styleRow?: React.CSSProperties;
  render?: (value: any, row: any) => React.ReactNode;
  groups?: {
    label: string;
    key: string;
    style?: React.CSSProperties;
    styleRow?: React.CSSProperties;
  }[];
};

const ShortStayUsageDays = () => {
  const headerColumns = [
    {
      label: "前月までの利用日数",
      key: "previousMonthUsageDays",
      style: {
        width: "22mm",
      },
    },
    {
      label: "当月の計画利用日数",
      key: "plannedUsageDaysThisMonth",
      style: {
        width: "22mm",
      },
    },
    {
      label: "累積利用日数",
      key: "cumulativeUsageDays",
      style: {
        width: "22mm",
      },
    },
  ] as HeaderColumn[];

  const data = [
    {previousMonthUsageDays: 0, plannedUsageDaysThisMonth: 0, cumulativeUsageDays: 0},
  ] as any[];

  const renderTableHeader = (headerColumns: HeaderColumn[]) => {
    return (
      <thead>
        <tr>
          {headerColumns.map((column) => {
            return (
              <th
                key={column.key}
                rowSpan={2}
                style={{ ...column.style }}
                className="p-0 text-center whitespace-pre-line text-[9px] font-normal leading-[1.1]"
              >
                <div className="min-h-[6mm] flex items-center justify-center" style={{ ...column.style, ...column.styleRow }}>
                  {column.label}
                </div>
              </th>
            );
          })}
        </tr>
      </thead>
    );
  };

  const renderTableBody = () => {
    return (
      <tbody>
        {data.map((row, index) => (
          <tr key={index}>
            {headerColumns.map((column) => {
              return (
                <td
                  key={column.key}
                  className="p-0"
                  style={{ ...column.style, ...column.styleRow }}
                >
                  <div className="min-h-[6mm] text-right text-base mr-1 flex items-center justify-end h-[6mm]" style={{ ...column.style, ...column.styleRow }}>
                    {column.render ? column.render(row[column.key], row) : row[column.key]}
                  </div>
                </td>
              );
            })}
          </tr>
        ))}
      </tbody>
    );
  };

  return (
    <div className="mt-1">
      <div className="text-xs">要介護認定期間中の短期入所利用日数</div>
      <table className="mt-[0.5mm] table-fixed">
        {renderTableHeader(headerColumns)}
        {renderTableBody()}
      </table>
    </div>
  );
};
export default ShortStayUsageDays;
